/**
 * Assertions for Trade Data Integrity
 */
const assertTradeIntegrity = (trades) => {
  if (!Array.isArray(trades) || trades.length === 0) {
    throw new Error("Assertion Failed: No trade data available for export.");
  }

  const requiredFields = ['ticker', 'buy_date', 'buy_price'];
  trades.forEach((trade, i) => {
    requiredFields.forEach(field => {
      if (trade[field] === undefined || trade[field] === null) {
        throw new Error(`Assertion Failed: Trade at index ${i} is missing ${field}`);
      }
    });
  });

  return true;
};

/**
 * Browser-side CSV Generation
 * Uses the trades already in React state to generate a file without a server call.
 */
export const downloadTradesAsCsv = (trades, runName = 'backtest_results') => {
  try {
    if (!trades || trades.length === 0) {
      throw new Error("No trade data available to export.");
    }

    // 1. DYNAMIC COLUMN DETECTION
    // Instead of hardcoding keys that might not exist in the Python DF,
    // we take the keys from the first trade object.
    const allKeys = Object.keys(trades[0]);
    const headers = allKeys.join(",");
    
    // 2. DATA MAPPING
    const rows = trades.map(trade => {
      return allKeys.map(key => {
        let value = trade[key] ?? "";
        // Handle potential commas in data to prevent shifting columns
        if (typeof value === 'string' && value.includes(',')) {
          return `"${value}"`;
        }
        return value;
      }).join(",");
    }).join("\n");

    const csvContent = `${headers}\n${rows}`;

    // 3. TRIGGER DOWNLOAD
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    
    // Clean filename
    const safeName = runName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
    const filename = `${safeName}_${new Date().toISOString().split('T')[0]}.csv`;
    
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    return { success: true };
  } catch (error) {
    console.error("CSV Generation Error:", error.message);
    return { success: false, error: error.message };
  }
};